import { css } from 'twind/css'

export const menuButtonTrigger = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 36px;
  aspect-ratio: 1;
  background-color: transparent;
  overflow: hidden;
  cursor: pointer;
`

export const menuButtonPlus = css`
  color: var(--blk2);
  font-weight: var(--font-medium);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-xl);
`

export const menuButtonMenu = css`
  z-index: 999;
  background-color: var(--white);
  border-radius: var(--border-radius-sm);
  box-shadow:
    0px 3px 6px -4px #0000001f,
    0px 6px 16px 0px #00000014,
    0px 9px 28px 8px #0000000d;
  width: auto;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: absolute;
  bottom: 100%;
`

export const menuButtonMenuItem = css`
  width: auto;
  padding: var(--spacing-4) var(--spacing-8);
  cursor: pointer;
  transition: var(--transition-all-medium);
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--blk2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 20px;

  &:hover {
    background-color: var(--gray-3);
  }
`
